import React from 'react';

import ReactSelect from 'react-select';

const OprSelect = (props) => {
  const { input: { value, onChange } } = props;
  return (
    <ReactSelect {...props}
      isClearable
      isSearchable={false}
      backspaceRemoves={false}
      value={value}
      onChange={onChange}
      deleteRemoves={false}
      options={[
        { value: '>', label: '>' },
        { value: '>=', label: '>=' },
        { value: '=', label: '=' },
        { value: '<=', label: '<=' },
        { value: '<', label: '<' }
      ]}
    />
  );
}

export default OprSelect;
